import React, { useEffect, useState } from 'react'
import '../../styles/style.css';
import '../../styles/navbar.css';
import '../../styles/adminrole.css';

import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL, handleStorage } from '../../constant/Utility'

function Login() {

  const base_url = BASE_URL;
  // const base_url = 'http://127.0.0.1:8000/';

  var form_data = new FormData();
  const [pageloading, setLoading] = useState(false);
  const [type, setType] = useState(false);

  let navigate = useNavigate();
  const location = useLocation();

  const [formValue, setFormValue] = useState({});
  const [serviceData, setServiceData] = useState("");
  const [event, setEvent] = useState();
  const [message, setMessage] = useState("");

  function handleOnChange(e) {
    setServiceData("");
    setMessage("")
    const name = e.target.name;
    const values = e.target.value;
    setFormValue(value => ({ ...value, [name]: values }))
  }

  function handleOnSubmit(event) {
    setEvent(location.state?.eventId);
    setLoading(true);
    event.preventDefault();
    form_data = formValue;

    if (formValue !== {} && formValue.username && formValue.password) {
      axios({
        method: "post",
        url: base_url + "user/login",
        data: form_data,
        headers: { "Content-Type": "multipart/form-data" },
      }).then(response => {
        setServiceData(response.data);
        setLoading(false);
      }, error => {
        setServiceData(error.response.data.detail);
        setLoading(false);
        // Only show error if it's 400 or 401, not 404
        if (error.response && (error.response.status === 400 || error.response.status === 401)) {
          setServiceData(error.response.data);
        } else {
          setServiceData(""); // Don't show 404 or other errors
        }
      }).catch(error => {
        setLoading(false);
        setServiceData("")
      })
    } else {
      setMessage("Enter credentials");
      setLoading(false);
    }

  }

  const Loading = (status) => {
    if (status) {
        // document.body.setAttribute('style','overflow:hidden;height:100vh');
        return (
            <div className='app_content'>
                <div className="loading">Loading&#8230;</div>
            </div>
        )
    }else{
        document.body.setAttribute('style','overflow:visible;');
    }
  }

  useEffect(() => {
    handleStorage(1);
  }, [])




  function login_info() {
    if (serviceData) {
      if (serviceData.access_token) {
        sessionStorage.setItem('token', serviceData.access_token);
        sessionStorage.setItem('user_role', serviceData.role_id);
        if (serviceData.role_id == 1 || serviceData.role_id == 2 || serviceData.role_id == 9) {
          localStorage.setItem("admin",0);
          navigate('/admin/dashboard')
        } else {
          if (event != null) {
            navigate('/high_octavez/Event_details',
              { state: { event } })
          } else {
            navigate('/high_octavez/home')
          }
        }
      }
      else {
        return (<div style={{ 'color': 'red', 'textAlign': 'center' }} className="h3">{serviceData.detail}</div>)
      }
    }
  }



  return (
    <div className='event_page_black_theme login_high'>

      <div>
        <section id="login_arae" className="section_padding d-flex align-items-center vh-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                <div className="section_heading text-white">
                  <h3>Login your account</h3>
                  <h2>Join our <span className="color_big_heading">community</span> to help peoples</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 offset-lg-3">
                <div className="author_form_area">
                  {login_info()}
                  <div style={{ 'color': 'red', 'textAlign': 'center' }} className="h3">{message}</div>
                  {/* <form action="#!" id="author_form" > */}
                  <div className="form-group mt-2">
                    <input type="text" className="custum-control form-control" placeholder="Email" name='username' value={formValue.username || ''} onChange={(e) => { handleOnChange(e) }} required />
                  </div>
                  <div className="form-group mt-4">
                    <div className='input-group'>
                      <input type={type ? "text" : "password"} className="custum-control form-control" placeholder="Password" name='password' value={formValue.password || ""}
                        onChange={(e) => { handleOnChange(e) }} required />
                      <span className='input-group-text'><i className={type ? "fas fa-eye-slash" : "fas fa-eye"} onClick={() => { setType(!type) }} style={{ cursor: 'pointer' }} ></i></span>
                    </div>
                  </div>
                  <div className="author_submit_form">
                    <button className="btn btn_theme btn_md" type='button' onClick={(e) => { handleOnSubmit(e) }}>Login</button>
                    <p className='mb-2'>Dont have an account? <Link to="/high_octavez/register">Register now</Link></p>
                    <Link to="/high_octavez/home">Back to Home</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>


      {Loading(pageloading)}
    </div>
  )
}

export default Login